const EasyMarketsDataEnum = {
	language: () => easymarkets.data.language,
	isWidget: () => !!easymarkets.data.widget,
	isLoggedIn: () => easymarkets.data.logged_in,
	slug: () => easymarkets.data.slug,
	Slugs: window.slugs || {},
	culture: () => easymarkets.data.culture,
	site: () => easymarkets.data.site,
	hasCulture: (cultureToCheck) => easymarkets.data.culture.toLowerCase() === cultureToCheck.toLowerCase(),
	isInTradezone: () => easymarkets.data.slug === 'trade',
	cultureWithLanguage: () => easymarkets.data.culture.toUpperCase() + '-' + easymarkets.data.language.toUpperCase(),
	baseUrl: () => easymarkets.data.base_url,
	jsApiUrl: () => easymarkets.data.jsapi_url,
	path: () => easymarkets.data.path,
	getUrlFor: (path) => EasyMarketsDataEnum.baseUrl() + path,
	mt4: () => easymarkets.data.mt4,
	mt5: () => easymarkets.data.mt5,
	jsapiUrl: () => easymarkets.data.jsapi_url,
	chartsWebUrl: () => easymarkets.data.charts_web_url,
	rollingFeeTime: () => easymarkets.data.rollingFeeTime,
	uid: () => easymarkets.data.uid,
	deprecatedLanguage: () => easymarkets.data.deprecated_language,
	rootDomain: () => easymarkets.data.root_domain,
	cookieDomain: () => easymarkets.data.cookie_domain,
};

export default EasyMarketsDataEnum;
